







import { Component, Mixins } from 'vue-property-decorator'
import DexieService from '@/services/dexie-service'
import SnackbarService from '@/services/snackbar-service'
import AuthService from '@/services/auth-service'
import Payment from '@/components/settings/payment/Payment.vue'
import Account from '@/components/settings/account/Account.vue'

@Component({
  components: {
    Payment,
    Account,
  },
})
export default class SettingsView extends Mixins(
  DexieService,
  SnackbarService,
  AuthService
) {
  created() {
    this.$store.state.showAppbar = true
    this.$store.state.changeBack = '/home'
    this.$store.state.navbarText = 'Settings'
  }
}
